import React, { useState } from 'react';
import './Contact.css';
import SEO from '../../components/SEO/SEO';


const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        budget: '',
        message: ''
    });

    const [formStatus, setFormStatus] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically send the form data to your backend
        console.log('Form submitted:', formData);
        setFormStatus('Thank you! We\'ll get back to you within 24 hours.');

        // Reset form
        setTimeout(() => {
            setFormData({
                name: '',
                email: '',
                phone: '',
                company: '',
                service: '',
                budget: '',
                message: ''
            });
            setFormStatus('');
        }, 3000);
    };

    return (
        <div className="contact-page">
            <SEO
                title="Contact Us"
                description="Get in touch with Digi Network to start your digital growth journey. We offer free consultations for SEO, PPC, and Web Development services."
                canonical="/contact"
            />
            {/* Hero Section */}
            <section className="contact-hero">
                <div className="contact-hero-bg"></div>
                <div className="container">
                    <div className="contact-hero-content">
                        <div className="label">GET IN TOUCH</div>
                        <h1>Let's Start Your Next Project</h1>
                        <p>Ready to accelerate your growth? Schedule a free consultation with our digital marketing experts and discover how we can help you dominate your market through strategic SEO, high-converting ads, and stunning web development.</p>
                    </div>
                </div>
            </section>

            {/* Contact Content */}
            <section className="contact-content">
                <div className="container">
                    {/* IMAGE PLACEHOLDER: Add team photo or office photo here (recommended size: 100% width, 400px height) */}
                    <div className="contact-visual">
                        <div className="contact-visual-placeholder">
                            <p>👥 Add Team Photo or Office Photo</p>
                        </div>
                    </div>

                    <div className="contact-grid">
                        {/* Contact Form */}
                        <div className="contact-form-wrapper">
                            <h2>Send Us a Message</h2>
                            <p className="form-intro">Fill out the form below and we'll get back to you within 24 hours.</p>

                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="name">Full Name *</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            placeholder="John Doe"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email">Email Address *</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="john@company.com"
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone Number</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="+1 (555) 123-4567"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="company">Company Name</label>
                                        <input
                                            type="text"
                                            id="company"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleChange}
                                            placeholder="Your Company"
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="service">Service Interested In *</label>
                                        <select
                                            id="service"
                                            name="service"
                                            value={formData.service}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select a service</option>
                                            <option value="seo">SEO Services</option>
                                            <option value="paid-ads">Paid Advertising (Meta, Google, LinkedIn, TikTok)</option>
                                            <option value="web-dev">Web Development & Design</option>
                                            <option value="full-service">Full-Service Digital Marketing</option>
                                            <option value="consultation">Free Consultation</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="budget">Monthly Budget</label>
                                        <select
                                            id="budget"
                                            name="budget"
                                            value={formData.budget}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select budget range</option>
                                            <option value="under-1k">Under $1,000</option>
                                            <option value="1k-3k">$1,000 - $3,000</option>
                                            <option value="3k-5k">$3,000 - $5,000</option>
                                            <option value="5k-10k">$5,000 - $10,000</option>
                                            <option value="10k-plus">$10,000+</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message">Tell Us About Your Project *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="6"
                                        placeholder="Tell us about your goals, challenges, and what you're looking to achieve..."
                                    ></textarea>
                                </div>

                                <button type="submit" className="btn btn-primary">
                                    Send Message
                                    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                    </svg>
                                </button>

                                {formStatus && (
                                    <div className="form-status success">{formStatus}</div>
                                )}
                            </form>
                        </div>

                        {/* Contact Info */}
                        <div className="contact-info-wrapper">
                            <div className="contact-info-card">
                                <h3>Contact Information</h3>
                                <p>Get in touch with us through any of these channels:</p>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">📧</div>
                                    <div>
                                        <h4>Email Us</h4>
                                        <a href="mailto:ali@diginetworkads.com">ali@diginetworkads.com</a>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">📞</div>
                                    <div>
                                        <h4>Call Us</h4>
                                        <a href="tel:+923004817173">+92 300 4817173</a>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">⏰</div>
                                    <div>
                                        <h4>Business Hours</h4>
                                        <p>Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday - Sunday: Closed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-info-card social-card">
                                <h3>Follow Us</h3>
                                <div className="social-links-contact">
                                    <a href="https://www.linkedin.com/company/digi-network/" className="social-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                    <a href="https://web.facebook.com/DiginetworkFB" className="social-link" target="_blank" rel="noopener noreferrer">Facebook</a>
                                    <a href="https://www.instagram.com/thediginetwork/" className="social-link" target="_blank" rel="noopener noreferrer">Instagram</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="contact-faq">
                <div className="container">
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq-grid">
                        <div className="faq-item">
                            <h4>How quickly can we get started?</h4>
                            <p>We can typically begin work within 1-2 weeks after our initial consultation and contract signing.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What's included in the free consultation?</h4>
                            <p>We'll review your current digital presence, discuss your goals, and provide initial recommendations at no cost.</p>
                        </div>
                        <div className="faq-item">
                            <h4>Do you work with businesses in my industry?</h4>
                            <p>We have experience across multiple industries including e-commerce, B2B, healthcare, finance, and more.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What are your contract terms?</h4>
                            <p>We offer flexible contracts starting from 3 months, with options for both monthly and annual agreements.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
